import { useContext } from 'react';

import { FolderContext, type IFolderContextData } from '../contexts/folder';

export const useFolder = (): IFolderContextData => useContext(FolderContext);
